<template>
        <b-btn data-test-path="header-attachments-button" @click="openAttachments"
               variant="plm-toolbar-secondary" class="m-1" style="width: 42px">
          <font-awesome-icon icon="paperclip" />
        </b-btn>
</template>

<script>


import ActivityManager from "@/activity/ActivityManager";
import {getFileSizeFormatter} from "@/components/datagrid/ColumnFormatter";
import FormValidatedField from "@/components/forms/FormValidatedField";
const AttachmentsActivity = () => require("@/components/forms/renderers/attachments/AttachmentsActivity");

export default {
  name: "AttachmentsList",

  mounted() {
    this.loadAttachments();
    this.validatedField = this.form.validatedFieldsByName.get("attachments");

  },
  props: {
    entityInstance: {default: null},
    readOnlyMode: {default: null},
    form: {default: null},
  },
  methods: {

    async loadAttachments() {
      if (this.validatedField.value) {
        this.numberOfAttachments = this.validatedField.value.length;
        this.attachmentsList = [...this.validatedField.value];
      } else {
        this.attachmentsList = [];
      }

      for (let i = 0; i < this.attachmentsList.length; i++) {
        this.attachmentsList[i].data.sizeLabel = getFileSizeFormatter(this.attachmentsList[i].data.size);
      }
    },

    fixResultOfAttachments(removedTokens) {
      this.attachmentsList = _.filter(this.attachmentsList, (attachment) => {
        return !_.includes(removedTokens, attachment.token);
      });
      this.validatedField.value = this.attachmentsList;
      this.numberOfAttachments = this.attachmentsList.length;
    },
    async openAttachments() {

      let entityId = this.validatedField.validatedForm?.originalSource?.id;

      const activity = await ActivityManager.showActivity(AttachmentsActivity, {
        attachments: this.attachmentsList,
        validatedField: this.validatedField,
        canEdit: !this.readOnlyMode
      });

      let handler;
      activity.$on('save',handler = async attachmentDialogResult => {
        if (attachmentDialogResult.numberOfUnsavedAttachments) {
          this.attachmentsList = attachmentDialogResult.attachmentsList;
          this.validatedField.value = this.attachmentsList;
          this.numberOfAttachments = this.attachmentsList.length;
          if (entityId) {
            await this.validatedField.saveField();
          }
        }
        this.fixResultOfAttachments(attachmentDialogResult.deletedTokens);
      });

      activity.$on('close', handler = async unsavedTokens => {
        this.fixResultOfAttachments(unsavedTokens);
      });

      await activity.getResult();
      activity.$off('save', handler);
      activity.$off('close', handler);
    }
  },
  watch: {
    'validatedField': function (val) {
      this.loadAttachments();
    },
    'validatedField.value': function (val) {
      this.loadAttachments();
    }
  },

  data: () => ({
    readOnly: true,
    editorMode: false,
    numberOfAttachments: 0,
    numberOfUnsavedAttachments: 0,
    attachmentsList: [],
    validatedField: FormValidatedField,
  })
}
</script>
